import React from 'react';
import { Block, CaptionableBlockContent } from '../types';
import { ControlPanelSwitchButton } from './control-panel/switch';
import { NeueQuoteRegularIcon } from 'src/monet/icons';
import { useBlockActions } from '../helpers/actions/use-block-actions.hook';

interface Props {
  block: Block;
  disabled?: boolean;
}

export const ToggleBlockCaption = ({ block }: Props) => {
  const blockContent = block.content as CaptionableBlockContent;
  const { onBlockParamsChange } = useBlockActions(block);

  return (
    <ControlPanelSwitchButton
      label='Add caption'
      icon={<NeueQuoteRegularIcon className='shrink-0' />}
      checked={blockContent.caption?.enabled || false}
      onChange={(value) => {
        onBlockParamsChange(block.id, {
          caption: {
            ...(blockContent.caption || {}),
            enabled: value,
          },
        });
      }}
    />
  );
};
